import { TableHeadItemRecurse } from '../../../../../../components/TableHead';

export const tableHead: TableHeadItemRecurse[] = [
  { title: 'Gestor', flex: 1.5 },
  { title: 'CNPJ', flex: 2 },
  { title: 'Categoria', flex: 2 },
  { title: 'Nome', flex: 2.5 },
  { title: 'Bloqueios', flex: 2 },
  { title: 'Controle', flex: 2 },
];
